import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import NotPermissionComponent from "../NotPermissionComponent";
import {useFindChecklistOfac} from "../../../services/apis/apiChecklist";
import {ChecklistOfacDetailInterface} from "../../../services/interface/query/checklist-interface";
import NoRecords from "../../components/NoRecords";
import * as IconsMui from "@mui/icons-material";
import {IconButton, Collapse} from "@material-tailwind/react";
import CustomTable from "../../../components/general/CustomTable";

interface Props {
    person?: Person;
}

/**
 * Muestra coincidencias OFAC asociadas a la persona consultada.
 * Consume el endpoint POST /control_lists/ofac.
 *
 * @author cfernandez
 * @version 1.0.0
 * @since 2026-04-08
 */
export default function ChecklistOfac({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findOfac,
        data: successOfac,
        error: errorOfac,
        isPending: loadingOfac,
    } = useFindChecklistOfac()

    const [response, setResponse] = useState<ChecklistOfacDetailInterface[] | null | undefined>()
    const [isOpen, setIsOpen] = React.useState(false);

    useEffect(() => {
        if (person?.identification) {
            setResponse(undefined)
            findOfac({identifier: person.identification, msj: t('ofac')})
        }
    }, [person]);

    useEffect(() => {
        if (successOfac !== undefined) {
            setResponse(successOfac);
        }
    }, [successOfac]);

    const isResolved = response !== undefined && response !== null;
    const hasRecords = isResolved && response.length > 0;

    return (
        <NotPermissionComponent
            className={'min-h-[50px]'}
            title={'/pn_checklist'}
            loading={loadingOfac}
            error={errorOfac}
            component={
                <div>
                    <div className={'flex flex-row gap-3 !border border-transparent border-b-secondary pb-3'}>
                        {isResolved ?
                            !hasRecords ?
                                <IconsMui.EmojiEmotionsTwoTone className={'text-success'}/> :
                                <IconsMui.SentimentDissatisfiedTwoTone className={'text-danger'}/> :
                            <IconsMui.NotificationsOffTwoTone className={'text-empColorSecondary'}/>
                        }
                        {t('ofac')}
                        <div className={'ml-auto flex flex-row gap-3 items-center'}>
                            {hasRecords &&
                                <div className={'text-[9px] font-light text-danger'}>{t('ofac')}</div>}
                            {hasRecords &&
                                <IconButton placeholder="icon-button"
                                            size="sm"
                                            variant="text"
                                            onClick={() => setIsOpen((cur) => !cur)}
                                >
                                    <IconsMui.KeyboardArrowDownTwoTone className="h-6 w-6"/>
                                </IconButton>
                            }
                        </div>
                    </div>
                    {hasRecords ?
                        <Collapse open={isOpen} className="bg-white">
                            <CustomTable
                                classNameTable={'mt-2'}
                                header={[
                                    t('names'),
                                    t('cl-sdn-type'),
                                    t('cl-sanction-program'),
                                    t('cl-title'),
                                    t('observations'),
                                    t('date-update'),
                                ]}
                                listElement={response?.map((item) => ({
                                    row: [
                                        item.name,
                                        item.sdnTypeName,
                                        item.sanctionProgramName,
                                        item.title,
                                        item.observations,
                                        item.updateDate,
                                    ]
                                }))}
                            />
                        </Collapse>
                        : !loadingOfac && isResolved && <NoRecords/>
                    }
                </div>
            }
        />
    )
}
